import { IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonInputPasswordToggle, IonLoading, IonPage, IonRow, IonSelect, IonSelectOption, IonSpinner, IonTitle, IonToolbar, useIonRouter, useIonViewDidEnter, useIonViewDidLeave, useIonViewWillEnter } from '@ionic/react';
import React, { useState, useRef, useEffect } from 'react';
import { chevronBackOutline,logInOutline } from 'ionicons/icons';
import { Link } from 'react-router-dom';
import { useAppContext } from '../AppProvider';
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';
import { configureRevenueCat } from '../lib/RevenueCat';
import { getBillingAdapter } from '../components/getBillingAdapter';

const billing = getBillingAdapter();

const Login: React.FC = () => {
    const [disableSubmit, setDisableSubmit] = useState<boolean>(true);

    const { networkStatus, appStatus, setAppStatus, getAppStatus, authKey, setAuthKey, authenticateMember, getAuthorizedMember, setShowLoader, getLevel, setLevel, getLevels, getUserTimezone, settings, getSettings, SWFullHorizLogo, textLogoLoaded, fadeInTextLogo, Preferences, showToast, present, dismiss } = useAppContext();
    
    const router = useIonRouter();
    const emailInput = useRef<any>();
    const passcodeInput = useRef<any>();
    const sessionInput = useRef<any>();
    const loginBtn = useRef<HTMLIonButtonElement>(null);
    const loadingOverlay = useRef<any>();
    const platform = Capacitor.getPlatform();

    useIonViewWillEnter(() => {
        document.body.classList.remove('dark');
    });
    
    //
    // Authenticate Member
    //
    useIonViewWillEnter(() => { 
        setShowLoader(true);
        const authenticate = async () => {
            const appstat = await getAppStatus();
            
            if (!networkStatus || appstat === 'No') {
                router.push('/connection', 'forward');
            } else {                
                const authenticated = await authenticateMember();  
                //console.log(authenticated); 
                if(!authenticated || authenticated.mt == '') {
                    setShowLoader(false); 
                } else if(authenticated && authenticated.mt != '') {
                    const member = await getAuthorizedMember(authenticated.mt);  
                    const userLevel = await getLevel(authenticated.mt);
                    setLevel(userLevel);
                    await getLevels();
                    loginBtn.current?.blur();
                    dismiss();
                    //console.log(member);
                    if(member.accountSetupPct < 75) router.push('/onboarding'); // , 'forward'
                    else if(member.accountSetupPct >= 75) router.push('/account/dashboard');  // , 'forward' 
                }
            }
        };        
                
        authenticate();
    });

    
    /*useEffect(() => {
        console.log(networkStatus, appStatus, authKey);
        if (networkStatus && (appStatus === 'Fast' || appStatus === 'Slow') && Object.keys(authKey).length > 0) {
            console.log('Re-connected');
            router.push('/account/dashboard', 'forward');
        } else setLoading(false);
    }, [networkStatus, appStatus, authKey]);   */ 


    //
    // Clear the log-in form upon leaving page
    //
    useIonViewDidLeave(() => {
        emailInput.current.value = '';
        passcodeInput.current.value = '';
        setDisableSubmit(true);
    });


    //
    // Validate Form
    //
    const validateForm = () => {
        const email = emailInput.current.value;
        const passcode = passcodeInput.current.value;
        const disable = (email == '' || email.includes('@') == false || email.includes('.') == false || passcode.length < 8);
        if (loginBtn.current !== null) {
            loginBtn.current.disabled = disable;
            loginBtn.current.color = disable ? 'primary' : 'secondary';
        }
    };


    //
    // Submit Log-in
    //
    const submitLogin = async (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        await present('Logging in...');

        try {
            const form = e.target; 
            const formData = new FormData(form);
            const response = await fetch('https://api.besolowise.com/members/authenticate/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });

            if(response.ok) {
                const obj = await response.json(); 
                
                if(obj.success) {
                    let newAuthKey = obj; 
                    delete obj.message;

                    await configureRevenueCat(obj.mt);
                    
                    const member = await getAuthorizedMember(obj.mt);  
                    
                    setAuthKey(newAuthKey);
                    await Preferences.set({ key: 'solowise', value: JSON.stringify(obj)});

                    //
                    // Post the mobile push token data
                    //
                    if (platform === 'android' || platform === 'ios') {
                        let pushToken = localStorage.getItem('pushToken');
                        if (pushToken) { 
                            const deviceId = await Device.getId();
                            const deviceInfo = await Device.getInfo();
                            const body = { 'mt': obj.mt,
                                           'platform': platform,
                                           'pushToken': pushToken,
                                           'deviceUuid': deviceId.identifier,
                                           'deviceLabel': deviceInfo.manufacturer,
                                           'deviceModel': deviceInfo.model,
                                           'appVersion': '1.2.1',
                                         };
                                            
                            const res = await fetch('https://api.besolowise.com/mobile-push/register/', {
                                method: 'POST',
                                credentials: 'include',
                                body: JSON.stringify(body),
                            });
                            
                            if (!res.ok) {
                                console.log('!ok'); 
                                const text = await res.text().catch(() => '');
                                throw new Error(`subscribe.php failed: ${res.status} ${res.statusText} – ${text}`);
                            } else {
                                const tokenObj = await res.json();    
                                console.log(tokenObj);                    
                                //return newSub; //obj; // { ok, stored, updated, endpoint }
                            }
                        }
                    }


                    //await getSettings(obj.tokenUserID);
                    const userLevel = await getLevel(obj.mt);
                    setLevel(userLevel);
                    await getLevels();
                    
                    const displayName = [member.memberFirstName, member.memberLastName]
                        .filter(Boolean)
                        .join(' ');

                    await billing.setAttributes?.({
                        ...(member.memberEmail ? { '$email': member.memberEmail } : {}),
                        ...(displayName ? { '$displayName': displayName } : {}),
                        ...(member.memberFirstName ? { firstName: member.memberFirstName } : {}),
                        ...(member.memberLastName ? { lastName: member.memberLastName } : {}),
                    });

                    loginBtn.current?.blur();
                    dismiss();

                    if(member.accountSetupPct < 75) router.push('/onboarding'); // , 'forward'
                    else if(member.accountSetupPct >= 75) router.push('/account/dashboard');  // , 'forward'        
                } else {
                    setAuthKey({});
                    dismiss();
                    showToast({
                        message: 'Log-in Error: ' + obj.message,
                        duration: 3000,
                        color: 'danger'
                    });
                    if(obj.ecode == 'EXCEEDED LIMIT') {
                        emailInput.current.value = '';
                        passcodeInput.current.value = '';
                        setDisableSubmit(true);
                    }
                }

            } else {
                setAuthKey({});
                dismiss();
                showToast({
                    message: 'Response Error. Try again.',
                    duration: 2000,
                    color: 'danger'
                });  
            }   

        } catch(error) {
            console.log(error);
            setAuthKey({});
            dismiss();
            showToast({
                message: 'No Connection',
                duration: 2000,
                color: 'dark'
            });
        } 
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonButton color={'tertiary'} routerLink='/'><IonIcon icon={chevronBackOutline}></IonIcon></IonButton>
                    </IonButtons>
                    <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding home-content-bg-1" fullscreen>
                <div className='ion-padding-bottom'>
                    <h1 className='ion-text-center'>Account Log In</h1>
                </div>
                <IonGrid fixed>
                    <IonRow class='ion-justify-content-center'>
                        <IonCol size='12' sizeMd='8' sizeLg='6' sizeXl='4'>
                            <IonCard style={{background: 'rgba(255, 255, 255, 0.90)', borderTop: 'none'}}>
                                <IonCardContent>
                                    <form onSubmit={submitLogin}>                                                
                                        <IonInput className='ion-margin-top' fill='outline' label='Email address' labelPlacement='stacked' name='loginUsername' onIonInput={validateForm} placeholder='' ref={emailInput} type='email'></IonInput>
                                        
                                        <IonInput className='ion-margin-top' fill='outline' label='Passcode' labelPlacement='stacked' name='loginPasscode' onIonInput={validateForm} placeholder='' ref={passcodeInput} type='password'>
                                            <IonInputPasswordToggle color={'dark'} slot="end"></IonInputPasswordToggle>
                                        </IonInput>
                                        
                                        <IonSelect className='ion-margin-top' color={'secondary'} fill='outline' label='# of days to remain logged-in' labelPlacement='floating' name='loginSession' ref={sessionInput} value={'15'}>  
                                            <IonSelectOption value='1'>1</IonSelectOption>
                                            <IonSelectOption value='15'>15</IonSelectOption>
                                            <IonSelectOption value='30'>30</IonSelectOption>
                                        </IonSelect>
                                        
                                        <input type="hidden" name="loginForward" value="account"></input>
                                        <IonButton className='ion-margin-top ion-margin-bottom' color={disableSubmit ? 'primary' : 'secondary'} type='submit' expand='block' ref={loginBtn} disabled={disableSubmit}>
                                            Log In <IonIcon icon={logInOutline} slot='end'></IonIcon>
                                        </IonButton>
                                        
                                        <p className='ion-text-center ion-margin'><Link to="/login/forgot-passcode" color={'tertiary'}><strong>Forgot your password?</strong></Link></p>
                                        
                                        <p className='ion-text-center ion-margin'><Link to="/register" color={'tertiary'}><strong>Create a new account</strong></Link></p>
                                    </form>
                                </IonCardContent>
                            </IonCard>  
                        </IonCol>
                    </IonRow>
                </IonGrid>     
            </IonContent>
        </IonPage>
    );
};

export default Login;